import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
  linearProgressBar: {
    marginTop: 4,
  }
})

export default useStyles